module.exports = "/images/scroll-base.svg?1a38d86439223349859862b32119e039";